import { createSlice } from '@reduxjs/toolkit';

import { FileReportUploadResponse } from '@fora-monorepo/employer-my-pages-common/types';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';
import { activePanelState, completePanelState, resetPanelState } from '@foradevelopment/fora-ui';

import { sendFileReport, uploadFileReport } from './fileThunks';
import { FileState } from './types/index';

export const initialFileState: FileState = {
  fileUploadPanelState: activePanelState(),
  reviewAndConfirmPanelState: resetPanelState(),
  receiptPanelState: resetPanelState(),
  fileResponse: null,
  receiptResponse: null,
  loadingUploadFileReport: ThunkRequestStatus.Fulfilled,
  loadingSendFileReport: ThunkRequestStatus.Fulfilled,
  fileUploadErrors: [],
};

const fileSlice = createSlice({
  name: 'file',
  initialState: initialFileState,
  reducers: {
    resetFileState: () => initialFileState,
    goToFileUploadPanel(state) {
      state.fileUploadPanelState = activePanelState();
      state.reviewAndConfirmPanelState = resetPanelState();
    },
    goToReviewAndConfirmPanel(state) {
      state.fileUploadPanelState = completePanelState();
      state.reviewAndConfirmPanelState = activePanelState();
    },
    goToReceiptPanel(state) {
      state.reviewAndConfirmPanelState = completePanelState();
      state.receiptPanelState = activePanelState();
    },
  },
  extraReducers: builder => {
    // Upload file
    builder.addCase(uploadFileReport.fulfilled, (state, action) => {
      if (action.payload) {
        state.fileResponse = action.payload as FileReportUploadResponse;
        state.loadingUploadFileReport = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(uploadFileReport.pending, state => {
      state.loadingUploadFileReport = ThunkRequestStatus.Pending;
    });
    builder.addCase(uploadFileReport.rejected, (state, action) => {
      state.fileUploadErrors = action.payload as string[];
      state.loadingUploadFileReport = ThunkRequestStatus.Rejected;
    });

    // Confirm file upload
    builder.addCase(sendFileReport.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingSendFileReport = ThunkRequestStatus.Fulfilled;
        state.receiptResponse = action.payload;
      }
    });
    builder.addCase(sendFileReport.pending, state => {
      state.loadingSendFileReport = ThunkRequestStatus.Pending;
    });
    builder.addCase(sendFileReport.rejected, state => {
      state.loadingSendFileReport = ThunkRequestStatus.Rejected;
    });
  },
});

export const { resetFileState, goToFileUploadPanel, goToReviewAndConfirmPanel, goToReceiptPanel } = fileSlice.actions;

export const fileReducer = fileSlice.reducer;
